import * as React from 'react';
import Heading from '@telia-front/heading';
import Icon from '@telia-front/icon';
class InternetSpeed extends React.Component {
    isGlobal() {
        const { downSpeed, upSpeed, downUnit, upUnit, collapsed } = this.props;
        return downSpeed === upSpeed && downUnit.unit === upUnit.unit && collapsed === true;
    }
    BEM() {
        const classArray = ['internet-speed', 'h4'];
        if (this.props.align) {
            classArray.push('internet-speed--' + this.props.align);
        }
        if (this.isGlobal()) {
            classArray.push('internet-speed--collapsed');
        }
        if (this.props.multiline && !this.props.collapsed) {
            classArray.push('internet-speed--multiline');
        }
        return classArray.join(' ');
    }
    renderSpeed(speed, unit) {
        return (React.createElement("span", { className: "internet-speed__speed" },
            React.createElement("span", { className: "h2 internet-speed__number" }, speed),
            React.createElement("span", { className: "internet-speed__unit" },
                unit.unit,
                React.createElement("br", null),
                unit.direction)));
    }
    getIcon(modifier) {
        return React.createElement(Icon, { modifiers: modifier, className: "internet-speed__icon" });
    }
    getMultilineIcons() {
        return (React.createElement("span", { className: "internet-speed__directions" },
            this.getIcon('#arrow-download'),
            this.getIcon('#arrow-upload')));
    }
    renderGlobalSpeed() {
        const { downSpeed, downUnit, upUnit } = this.props;
        return (React.createElement(React.Fragment, null,
            this.getIcon('#arrow-up-down'),
            React.createElement("span", { className: "internet-speed__speed" },
                React.createElement("span", { className: "h2 internet-speed__number" }, downSpeed),
                React.createElement("span", { className: "internet-speed__unit" },
                    downUnit.unit,
                    React.createElement("br", null),
                    downUnit.direction,
                    "/",
                    upUnit.direction))));
    }
    renderItems() {
        const { multiline, downSpeed, downUnit, upSpeed, upUnit } = this.props;
        if (this.isGlobal()) {
            return this.renderGlobalSpeed();
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "internet-speed__down" }, this.renderSpeed(downSpeed, downUnit)),
                !multiline && this.getIcon('#arrow-up-down'),
                React.createElement("span", { className: "internet-speed__up" }, this.renderSpeed(upSpeed, upUnit))));
        }
    }
    render() {
        const { headingLevel } = this.props;
        return (React.createElement(Heading, { className: this.BEM(), level: headingLevel },
            this.props.multiline && !this.props.collapsed && this.getMultilineIcons(),
            React.createElement("span", { className: "internet-speed__items" }, this.renderItems())));
    }
}
InternetSpeed.defaultProps = {
    headingLevel: 3,
};
export default InternetSpeed;
